export default __webpack_public_path__ + "static/media/settings-white.8dca2dbc.svg";